export default __webpack_public_path__ + "static/media/des-8.0a6e12b3.jpg";